type Environment = 'localhost' | 'staging' | 'production' | 'preview';

// Duplicated from apps/frontend on purpose: this package must stay independent of the host app.
function getEnvironment(): Environment {
  return window.location.hostname === 'app.e2n.de' ||
    window.location.hostname === 'manager.e2n.de'
    ? 'production'
    : window.location.hostname === 'staging.e2n.de' ||
        window.location.hostname === 'manager.staging.e2n.de'
      ? 'staging'
      : window.location.hostname === 'localhost'
        ? 'localhost'
        : 'preview';
}

const API_BASE_URL_PROD = 'https://api.ai.e2n.de';
const API_BASE_URL_STAGING = 'https://api.ai.staging.e2n.de';

export const apiBaseUrl =
  getEnvironment() === 'production' ? API_BASE_URL_PROD : API_BASE_URL_STAGING;

export const chatUrl = `${apiBaseUrl}/api/chat`;
export const sessionUrl = `${apiBaseUrl}/api/sessions`;
